@import "config";

.headerWrapper {
	width: 100%;

	.firstLine {
		width: 100%;

		@include flex(row, space-between, flex-end);
		padding: $spacing-inline-nano 0;

		.title {
			.description {
				margin-bottom: 0;
			}
		}
	}

	.secondLine {
		width: 100%;
		margin-top: $spacing-inline-nano;

		@include flex(row, flex-end, flex-end);

		.filters {
			width: 100%;
			@include flex(row, flex-start, center);
			gap: $spacing-inline-nano;
		}
	}

	.actions {
		@include flex(row, flex-end, flex-end);
	}

	.rangePicker {
		min-width: 260px;
		margin-left: $spacing-inline-nano;
		border-radius: $border-radius-sm;
	}

	.radioButtons {
		min-width: 196px;
		@include flex(row, flex-end, center);
		gap: $spacing-inline-nano;
	}

	.buttons {
		display: flex;
		gap: $spacing-inline-nano;
		margin-left: $spacing-inline-nano;
	}
}
